// Generated by Melange

import * as React from "react";

function initValue_1(param) {
  
}

const initValue = [
  /* Off */ 2,
  initValue_1
];

const context = React.createContext(initValue);

function useLoadingBar(param) {
  return React.useContext(context);
}

const LoadingBarContext = {
  initValue: initValue,
  context: context,
  useLoadingBar: useLoadingBar
};

const make = context.Provider;

function makeProps(value, children, param) {
  return {
    value: value,
    children: children
  };
}

const LoadingBarProvider = {
  make: make,
  makeProps: makeProps
};

function useLoadingBarContext(initialLoadingBar) {
  const match = React.useReducer((function (param, action) {
    switch (action) {
      case /* Start */ 0 :
        return /* Start */ 0;
      case /* Complete */ 1 :
        return /* Complete */ 1;
      case /* Off */ 2 :
        return /* Off */ 2;
    }
  }), initialLoadingBar);
  return [
    match[0],
    match[1]
  ];
}

export {
  LoadingBarContext,
  LoadingBarProvider,
  useLoadingBarContext,
}
/* context Not a pure module */
